import { numFormat } from "../../../com/dataUtil";

// ⋅ Top Browsers (pageview)
const TopBrowserChart = ({Highcharts, HighchartsReact ,topBrowserChartData }) => {

  // 차트 옵션
  const chartConfig = {
    chart: {
      backgroundColor: '#ffffff',
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      marginTop: 0,
      spacingTop: 0,
      height: 370
    },
    noData: {
      style:{
        color: '#444'
      }
    },
    title: {
      text: null
    },
    credits: {
      enabled: false
    },
    navigation: {
          buttonOptions: {
              enabled: false
          }
      },
    tooltip: {
        formatter: function () {
          return this.point.name + " : " + numFormat(this.point.y);
        }
    },
     legend: {
        x: 70,
        align: 'top',
        layout: 'vertical',
        verticalAlign: 'middle'
      },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            size: 300,
            // cursor: 'pointer',
            dataLabels: {
                enabled: true,
                distance: -35,
                format: ' {point.y:,.0f}',
                style: {
                      color: "#ffffff",
                      fontSize: "16px",
                      textOutline:"0px",
                      fontWeight:"400"
                }
            }
        }
    },
    series: [{
        name: 'Browsers',
        colorByPoint: true,
        innerSize: '55%',
        showInLegend: true,
        marker: {
            symbol: 'circle',
            radius: 12
        },
        data: topBrowserChartData
    }]
  };


  return(
    <>
      <HighchartsReact Highcharts = {Highcharts} options = {chartConfig} />
    </>
  )
}


export default TopBrowserChart;